import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IDateiliste } from "../types/Types";

/**
 * @author mb
 */
export const FileAPI = createApi({
    reducerPath: "fileAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "file",
            credentials: 'include'
        }),
    tagTypes: ['fileAPI'], // for caching
    endpoints: (builder) => ({
        remove: builder.mutation<any, string>(
            {
                query: (uid) => ({
                    url: '/remove/' + uid,
                    method: 'delete',
                    credentials: 'include'
                }),
                invalidatesTags: ["fileAPI"],
            }
        ),
        getTrashListAPI: builder.mutation<IDateiliste[], void>(
            {
                query: (dto) => ({
                    url: `/trashlist`,
                    method: 'get',
                    credentials: 'include',
                    body: dto
                })
            }
        ),
        restoreFile: builder.mutation<void, {uid:string}>(
            {
                query: (dto) => ({
                    url: `/restoreFile/` + dto.uid,
                    method: 'put',
                    credentials: 'include',
                })
            }
        ),
    })
});

export const {
    
    useRemoveMutation,
    useGetTrashListAPIMutation,
    useRestoreFileMutation,

} = FileAPI;
